import {ShapeCommand} from '../commands.template';
import {KEYS_TO_SANITIZE} from '../../shared/constants/keys-to-sanitize.constants';
import {v4 as uuidv4} from 'uuid';

export class ResourceAttachCommand extends ShapeCommand {
  protected services: any;
  private actMxKey = [];
  private position;
  private resource;
  private skipCalc;

  id = uuidv4();

  constructor(data) {
    super(data);

    if (data.mxKey) {
      this.actMxKey.push(Number(data.mxKey));
    }

    data.cells.forEach(cell => {
      const resources = cell.getJson().resources || [];
      const exists = resources.find(r => r.resourceDbId === data.resource.id);

      if (!exists) {
        this.actMxKey.push(Number(cell.id));
      }
    });

    this.resource = data.resource;
    this.position = data.position;
    this.skipCalc = data.skipCalc;
  }

  public execute() {
    super.execute();
    const cells = this.services.graphHelperSvc
      .allActivities()
      .filter(cell => this.actMxKey.indexOf(Number(cell.id)) !== -1);
    const resource = this.services.sanitizeXssService.sanitizeXss(
      this.resource,
      KEYS_TO_SANITIZE.ATTACHMENT
    );

    return this.services.resourceSvc.add({
      cells,
      resource,
      position: this.position,
      skipCalc: this.skipCalc,
      deltaKey: this.id
    });
  }

  public reverse() {
    super.reverse();
    const cells = this.services.graphHelperSvc
      .allActivities()
      .filter(cell => this.actMxKey.indexOf(Number(cell.id)) !== -1);

    return this.services.resourceSvc.remove({
      resource: this.resource,
      cells,
      deltaKey: this.id
    });
  }
}

/**

 attachResource: {
                    mxKey: resource.mxKey,
                    activityMxKey: parseInt(cell.id),
                    resourceDbId: resource.resourceDbId || resource.id,
                    resourceName: resource.name,
                    resourceType: resource.type,
                    position: opts.position
                }

 **/
